import { useMutation } from '@tanstack/react-query';

import { ConnectPageData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const disconnectPage = (data: ConnectPageData): Promise<void> => {
  return axios.post(`/${PLATFORM_URL_SEGMENT[data.platform]}/pages/disconnect`, data);
};

type DisconnectPageOptions = {
  config?: MutationConfig<typeof disconnectPage>;
};

export function useDisconnectPage({ config = {} }: DisconnectPageOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['pages']);
      config.onSuccess?.(...args);
    },
    mutationFn: disconnectPage,
  });
}
